export default "__VITE_ASSET__DY2Yj3up__"